import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import rTime from 'dayjs/plugin/relativeTime'
dayjs.locale('zh-cn')
dayjs.extend(rTime)
export const relativeTime = function (yourTime) {
  return dayjs().to(dayjs(yourTime))
}
